<template>
  <div class="ml-chart__container">
    <line-chart :colors="['#6CD1EF', '#5D538B']" :data="data" :download="true" :id="id" :height="height" legend="bottom" thousands=","></line-chart>
  </div>
</template>

<script>
import RandomString from 'randomstring'

export default {
  data () {
    return {
      id: ''
    }
  },
  methods: {
    initializeChartID () {
      this.id = RandomString.generate({length: 7, charset: 'alphabetic'})
    }
  },
  mounted () {
    this.initializeChartID()
  },
  name: 'Chart',
  props: {
    title: {
      type: String
    },
    data: {
      required: true
    },
    height: {
      type: String,
      default: '500'
    },
    legendPosition: {
      type: String,
      default: 'none'
    }
  }
}
</script>

<style lang="scss">
  @import "../styles/theme";
</style>



// WEBPACK FOOTER //
// src/components/Chart.vue